import {
  AvgebaeudeService,
  GebaeudeMasterDetailEntryMeta,
  GebaeudeMasterId,
  GebaeudeVersionDetailEntryMeta,
  GebaeudeVersionId,
  HistInfo
} from '../../../core/av-api';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { GebaeudeKopfdatenComponent } from './gebaeude-kopfdaten/gebaeude-kopfdaten.component';
import { RubrikComponent } from '../../../shared/components/rubrik/rubrik.component';
import { GebaeudeEingangsadressenComponent } from './gebaeude-eingangsadressen/gebaeude-eingangsadressen.component';
import { GebaeudeAufGrundstueckComponent } from './gebaeude-auf-grundstueck/gebaeude-auf-grundstueck.component';
import { CapSpinnerSmallComponent } from '../../../shared/components/cap-spinner-small/cap-spinner-small.component';
import { TranslatePipe } from '@ngx-translate/core';
import { KompaktGebaeudeMasterPipe } from '../../../shared/kompaktdarstellung/gebaeude/kompakt-gebaeude-master-pipe';
import { Subscription } from 'rxjs';
import { AppConfigService } from '../../../core/services/app-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TimepointService } from '../../../core/services/timepoint.service';
import { ComparatorService } from '../../../shared/services/comparator-service';
import HistEnumEnum = HistInfo.HistEnumEnum;

@Component({
  selector: 'cap-gebaeude-detail',
  templateUrl: './gebaeude-detail.component.html',
  styleUrls: ['./gebaeude-detail.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    GebaeudeKopfdatenComponent,
    RubrikComponent,
    GebaeudeEingangsadressenComponent,
    GebaeudeAufGrundstueckComponent,
    CapSpinnerSmallComponent,
    TranslatePipe,
    KompaktGebaeudeMasterPipe
  ]
})
export class GebaeudeDetailComponent implements OnInit, OnDestroy {
  gebaeude: GebaeudeMasterDetailEntryMeta;
  currentVersion: GebaeudeVersionDetailEntryMeta;
  gebaeudeVersionId: GebaeudeVersionId;
  gebaeudeMasterId: GebaeudeMasterId;
  egid: number;
  kantGid: number;
  readonly ID_PARAMETER_NAME = 'id';
  readonly VERSION_ID_PARAMETER_NAME = 'versionId';
  readonly EGID_PARAMETER_NAME = 'egid';
  readonly KANT_GID_PARAMETER_NAME = 'kantgid';
  private subscription: Subscription = new Subscription();

  constructor(
    private gebaeudeService: AvgebaeudeService,
    private appConfigService: AppConfigService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService,
    private comparatorService: ComparatorService
  ) {}

  static getGebaeudeVersionId(id: string): GebaeudeVersionId {
    return { id };
  }

  static getGebaeudeMasterId(id: string): GebaeudeMasterId {
    return { id };
  }

  public getCurrentVersion(): GebaeudeVersionDetailEntryMeta {
    if (this.gebaeudeVersionId.id || this.gebaeude.versions.length === 1) {
      return this.gebaeude.versions[0];
    } else {
      const version = this.gebaeude.versions.filter((value) => value.histInfo.histEnum === HistEnumEnum.VON_RECHTGUELTIG_BIS_NULL);
      if (!version || version.length === 0) {
        const sorted_versions = this.gebaeude.versions.sort((a, b) => this.comparatorService.timepointComparator(a.histInfo, b.histInfo));
        return sorted_versions[sorted_versions.length - 1];
      } else {
        return version[0];
      }
    }
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.gebaeudeVersionId = GebaeudeDetailComponent.getGebaeudeVersionId(params[this.VERSION_ID_PARAMETER_NAME]);
      this.gebaeudeMasterId = GebaeudeDetailComponent.getGebaeudeMasterId(params[this.ID_PARAMETER_NAME]);
      this.egid = params[this.EGID_PARAMETER_NAME];
      this.kantGid = params[this.KANT_GID_PARAMETER_NAME];
      this.subscription.add(this.appConfigService.einstellungHistorischeDaten$.subscribe((h) => this.loadData()));
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private loadData() {
    const z = this.timepointService.timepointCtx;
    if (this.gebaeudeMasterId && this.gebaeudeMasterId.id) {
      this.subscription.add(
        this.gebaeudeService
          .loadGebaeudeById(
            this.gebaeudeMasterId.id, //
            this.appConfigService.einstellungHistorischeDaten, //
            this.gebaeudeVersionId.id, //
            z.timepointIso, //
            z.timepointId //
          )
          .subscribe({
            next: (gebaeude) => {
              this.gebaeude = gebaeude;
              this.currentVersion = this.getCurrentVersion();
            },
            error: (err) => this.handleError(err)
          })
      );
    } else {
      this.subscription.add(
        this.gebaeudeService
          .loadGebaeudeByFachId(
            this.appConfigService.einstellungHistorischeDaten, //
            this.egid, //
            this.kantGid,
            z.timepointIso, //
            z.timepointId //
          )
          .subscribe({
            next: (gebaeude) => {
              this.gebaeude = gebaeude;
              this.currentVersion = this.getCurrentVersion();
            },
            error: (err) => this.handleError(err)
          })
      );
    }
  }

  private handleError(err: any) {
    if (err.status === 404) {
      this.router.navigate(['/home/notfound']);
    } else if (err.status === 403) {
      this.router.navigate(['security/forbidden']);
    } else {
      throw err;
    }
  }
}
